export enum EOrderStatus {
  OPEN = 'OPEN',
  WIN = 'WIN',
  LOSE = 'LOSE',
  DRAW = 'DRAW',
}

export enum EOrderOption {
  HIGHER = 'HIGHER',
  LOWER = 'LOWER',
}

export interface IOrder {
  orderId: number
  userId: number
  symbolId: number
  coinId: number
  amount: number
  profit: number
  status: EOrderStatus
  option: EOrderOption
  created: Date
  modified: Date
}
